export default "__VITE_ASSET__4a4757eb__"